// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1diMg","imageUploader":"EGiftCard_imageUploader__1R8ck"};